export class BarChartGMBModel {
  constructor() {
    this.chart = null;
    this._chartConfig = null;
  }

  makeChart(chartConfig) {
    this._setChartConfig(chartConfig);
    this._setChartConfigAsChart();
    this._setChartData();
    this._setChartOptions();
    this._setChartSum();
    this._setChartPercentage();
    this._setChartDataSetsLabels();
  }

  returnChart() {
    return this.chart;
  }

  _setChartConfig(chartConfig) {
    this._chartConfig = chartConfig;
  }

  _setChartConfigAsChart() {
    this.chart = this._chartConfig;
  }

  _setChartData() {
    this.chart.data = this.chart.relatedChartsData.map(
      (relatedChartData, idx) => {
        return {
          label: this.chart.labels[idx].text,
          backgroundColor: this.chart.colors[idx],
          data: relatedChartData.values.map(value => value.y).flat(),
          dataFormatted: relatedChartData.values
            .map(value => this._formatNumber(value.y))
            .flat()
        };
      }
    );
  }

  _formatNumber(value) {
    if (typeof value === "string" || value instanceof String) return value;
    return new Intl.NumberFormat("fr-FR").format(value);
  }

  _setChartOptions() {
    this.chart.options = {
      scales: {
        xAxes: [{ stacked: true }],
        yAxes: [{ stacked: true }]
      },
      tooltips: {
        callbacks: {
          title: function(tooltipItem, data) {
            return data["labels"][tooltipItem[0]["index"]];
          },
          label: function(tooltipItem, data) {
            return `${data["datasets"][tooltipItem["datasetIndex"]]["label"]} ${
              data["datasets"][tooltipItem["datasetIndex"]]["dataFormatted"][
                tooltipItem["index"]
              ]
            }`;
          }
        }
      }
    };
  }

  _setChartSum() {
    this.chart.sum = this.chart.relatedChartsData
      .map(relatedChartData => relatedChartData.sum)
      .reduce((a, b) => a + b, 0)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  _setChartPercentage() {
    const relatedChartsData = this.chart.relatedChartsData.filter(
      ({ periodPercentageDiff }) => typeof periodPercentageDiff !== "undefined"
    );
    const sum = relatedChartsData.reduce((sum, item) => sum + item.sum, 0);
    const compareSum = relatedChartsData.reduce(
      (sum, item) => sum + item.compareSum,
      0
    );

    if (relatedChartsData.length > 0) {
      if (compareSum > 0) {
        this.chart.percentage = ((sum / compareSum) * 100).toFixed(0) - 100;
      } else {
        this.chart.percentage = 100;
      }
    } else {
      this.chart.percentage = null;
    }
  }

  _setChartDataSetsLabels() {
    this.chart.dataSetsLabels = this.chart.relatedChartsData.map(
      relatedChartData => relatedChartData.values.map(value => value.t).flat()
    )[0];
  }
}
